import { GripVertical } from 'lucide-react';
import {
  Group,
  Panel,
  Separator,
  useDefaultLayout,
} from 'react-resizable-panels';

import { cn } from '@/lib/utils';

const ResizablePanelGroup = ({
  className,
  ...props
}: React.ComponentProps<typeof Group>): JSX.Element => (
  <Group className={cn('h-full w-full', className)} {...props} />
);

const ResizablePanel = Panel;

const ResizableHandle = ({
  withHandle,
  className,
  ...props
}: React.ComponentProps<typeof Separator> & {
  withHandle?: boolean;
}): JSX.Element => (
  <Separator
    className={cn(
      'group relative z-10 -mx-[22px] flex w-11 items-center justify-center bg-transparent',
      'before:absolute before:inset-y-0 before:left-1/2 before:w-px before:-translate-x-1/2 before:bg-border before:content-[""]',
      'hover:before:bg-primary/60 data-[separator=active]:before:bg-primary',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset',
      className
    )}
    {...props}
  >
    {withHandle && (
      <div className="z-10 flex h-11 w-5 items-center justify-center rounded-sm border bg-background shadow-sm group-hover:border-primary/60">
        <GripVertical className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
      </div>
    )}
  </Separator>
);

export {
  ResizablePanelGroup,
  ResizablePanel,
  ResizableHandle,
  useDefaultLayout as useResizableDefaultLayout,
};
